import {
  number as vNumber,
  object as vObject,
  optional as vOptional,
  string as vString,
  record as vRecord,
  unknown as vUnknown,
} from 'valibot';

// Those are other imports that might be useful
import type { LocationQueryRaw, RouteMapI18n } from 'vue-router';

// There might be a better way to do this, but I couldn't find it.
export type IadAppRoute<T extends keyof RouteMapI18n> = {
  name: RouteMapI18n[T]['name']
  params: RouteMapI18n[T]['params']
  query?: LocationQueryRaw
};

export const ErrorSchema = vObject({
  statusCode: vNumber(),
  statusMessage: vString(),
  data: vOptional(vObject({
    statusCode: vNumber(),
    statusMessage: vString(),
    data: vOptional(vRecord(vString(), vUnknown())),
  })),
});

type TrackingEventBase = 'agent_interaction' | 'alert_interaction' | 'generate_lead' | 'menu_interaction' | 'navigation' | 'search';
type TrackingEventName = 'click_to_call' | 'cta_click' | 'search_interaction';
export interface TrackingEvent {
  event: TrackingEventBase | (string & {})
  event_name?: TrackingEventName | (string & {})
  h_email?: string
  h_phone?: string
  lead_category?: 'estimate' | 'buyer' | 'seller' | 'rent'
  interaction_type?: 'open' | 'close'
  cta_type?: 'alert' | 'agent' | 'property'
  cta_name?: 'create_an_alert' | 'find_real_estate_agent' | 'contact_agent' | 'find_property'
  [key: string]: string | number | undefined | Array<string | number>
}
